var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocGen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.46 283.46",
    enableBackground: "new 0 0 283.46 283.46",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M204.64,32.22l12.24-0.02 c5.29-0.01,9.58,4.27,9.58,9.56v11.71"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M100.68,47.71l12.54-12.54 c1.79-1.79,4.21-2.8,6.75-2.8l84.67-0.15"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    x1: 71.59,
    y1: 76.8,
    x2: 100.68,
    y2: 47.71
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M77.36,251.53H65.67c-5.28,0-9.56-4.28-9.56-9.56 V96.24c0-2.54,1.01-4.97,2.8-6.76L71.59,76.8"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    x1: 119.97,
    y1: 71.73,
    x2: 119.97,
    y2: 32.36
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    x1: 56.11,
    y1: 96.24,
    x2: 95.46,
    y2: 96.24
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M56.11,230.16H44.36c-5.28,0-9.56-4.28-9.56-9.56 V74.87c0-2.54,1.01-4.97,2.8-6.76L91.91,13.8c1.79-1.79,4.21-2.8,6.75-2.8l96.91-0.17c5.29-0.01,9.58,4.27,9.58,9.56v9.54"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    x1: 98.66,
    y1: 49.73,
    x2: 98.66,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    x1: 34.8,
    y1: 74.87,
    x2: 73.52,
    y2: 74.87
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M248.67,62.86v200.21c0,5.28-4.28,9.56-9.56,9.56 H87.88c-5.28,0-9.56-4.28-9.56-9.56V117.35c0-2.54,1.01-4.97,2.8-6.76l54.32-54.32c1.79-1.79,4.21-2.8,6.75-2.8l96.91-0.17 C244.38,53.29,248.67,57.58,248.67,62.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M78.32,117.35h54.3c5.28,0,9.56-4.28,9.56-9.56 V53.47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.09,
    y: 146.74,
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    width: 122.81,
    height: 96.26
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 102.09,
    y1: 194.87,
    x2: 224.9,
    y2: 194.87
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 137.51,
    y1: 146.74,
    x2: 137.51,
    y2: 243
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 224.9,
    y1: 83.58,
    x2: 167.68,
    y2: 83.58
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 224.9,
    y1: 111.51,
    x2: 167.68,
    y2: 111.51
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocGen);
export default __webpack_public_path__ + "static/media/DOCGen.039b6d38be4b1e74dcac6fc7c33ca7c8.svg";
export { ForwardRef as ReactComponent };